import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Flame } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 65;
    const saved = sessionStorage.getItem('reflexo-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 62 + Math.floor(Math.random() * 6);
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 35
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('reflexo-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-rose via-[#D4738C] to-brand-rose text-white shadow-md" data-id="element-401">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-402">
        {/* Mobile: animated marquee with full content */}
        <div className="md:hidden overflow-hidden relative" data-id="element-403">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-404">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-405">
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-406">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-407" />
                  <span data-id="element-408">Precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5" data-id="element-409">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-white/40 shrink-0" data-id="element-410" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-411">
                  <Flame className="w-3.5 h-3.5 shrink-0 animate-pulse" data-id="element-412" />
                  <span data-id="element-413">
                    <strong className="tabular-nums" data-id="element-414">{spotsTaken}%</strong> de
                    cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-white/40 shrink-0" data-id="element-415" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-white text-brand-rose font-bold px-2.5 py-0.5 rounded-full text-[11px] shrink-0" data-id="element-416">
                  Ver kit →
                </a>
              </div>)}
          </motion.div>
        </div>

        {/* Desktop: keep existing static layout */}
        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-417">
          {/* Countdown */}
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap" data-id="element-418">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-419" />
            <span className="hidden sm:inline" data-id="element-420">
              Precio de lanzamiento cierra en
            </span>
            <span className="sm:hidden" data-id="element-421">Cierra en</span>
            <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5" data-id="element-422">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-4 bg-white/30 shrink-0" data-id="element-423" />

          {/* Spots */}
          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-424">
            <Flame className="w-4 h-4 shrink-0 animate-pulse" data-id="element-425" />
            <span data-id="element-426">
              <strong className="tabular-nums" data-id="element-427">{spotsTaken}%</strong> de cupos
              tomados
            </span>
          </div>

          {/* CTA */}
          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-white text-brand-rose font-bold px-3 py-1 rounded-full text-[11px] md:text-xs hover:bg-white/90 transition-colors shrink-0" data-id="element-428">
            Ver kit →
          </a>
        </div>
      </div>
    </div>;
}